import React from 'react';
import typographyPropTypes from '../prop-types/typographyPropTypes';
import SmallNote from './SmallNote';

var Small = function Small(_ref) {
  var color = _ref.color,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(SmallNote, {
    className: className,
    colorValue: color
  }, children);
};

Small.defaultProps = {
  color: 'dark',
  className: null,
  children: null
};
export default Small;